import type { FC } from 'react';
import styles from './SegmentVisualBuilder.module.css';

type Logic = 'and' | 'or';

interface LogicPillToggleProps {
  value: Logic;
  onChange: (value: Logic) => void;
  disabled?: boolean;
  ariaLabel?: string;
}

/** Segmented AND/OR pill, matching the tenant builder's logic switcher and the 1b design. */
export const LogicPillToggle: FC<LogicPillToggleProps> = ({
  value,
  onChange,
  disabled = false,
  ariaLabel = 'Combine conditions with',
}) => (
  <span className={styles.logicToggle} role="group" aria-label={ariaLabel}>
    <button
      type="button"
      className={styles.logicToggleOption}
      aria-pressed={value === 'and'}
      disabled={disabled}
      onClick={() => onChange('and')}>
      AND
    </button>
    <button
      type="button"
      className={styles.logicToggleOption}
      aria-pressed={value === 'or'}
      disabled={disabled}
      onClick={() => onChange('or')}>
      OR
    </button>
  </span>
);
